import Home from "./Pages/Home/Home";
import Work from "./Pages/Work/Work";
import {BrowserRouter, Route, Routes} from "react-router-dom";

function App() {
  return (
      <div className={'bg-[#f5f5f7] flex items-center justify-center'}>
        <div className={'md:w-3/5 w-screen sm:h-full'}>
            <BrowserRouter>
                <Routes>
                    <Route path={'/'} element={<Home />}/>
                    <Route path={'/work'} element={<Work />}/>
                </Routes>
            </BrowserRouter>
        </div>
      </div>
  );
}

export default App;
